/* =========================================================
GOLF TOWEL WORKS — MOBILE CUSTOMILY PREVIEW BUTTON BRIDGE A2 V4
---------------------------------------------------------
Visible behavior is unchanged:
- same card design, dimensions, placement, border and LIVE footer;
- compact card opens Customily's native Show Preview modal;
- same upward fade-out behavior;
- native #preview-canvas first, with Shopify gallery fallback;
- no upward re-scroll required after customization;
- no preview-node movement and no flicker.
Production performance:
- one narrowly scoped MutationObserver;
- no setInterval;
- no continuous animation loop;
- one passive scroll listener;
- full gallery scans are debounced and event-driven;
- scroll layout checks are cached and throttled;
- image mirrors are decoded before atomic replacement;
- canvas mirrors update only after relevant user/DOM changes.
========================================================= */
(function () {
"use strict";
const BUILD = "gtw-preview-customily-button-bridge-a2-v6-repeat-click";
const MOBILE_QUERY = "(max-width: 989px)";
const LAYOUT_CHECK_INTERVAL = 360;
const MIRROR_MAX_CSS_EDGE = 256;
const NATIVE_PREVIEW_CANVAS_SELECTOR =
"#preview-canvas.lower-canvas,canvas#preview-canvas";
const NATIVE_PREVIEW_BUTTON_SELECTOR =
"#customily-preview-button,button.customily-preview-button";
document.documentElement.setAttribute(
"data-gtw-towel-preview-build",
BUILD
);
const GALLERY_SELECTORS = [
"[data-gtw-mobile-shrink-gallery]",
".product__media-wrapper",
".product__media-gallery",
"media-gallery",
"[data-product-gallery]",
"[data-product-media-gallery]",
".product-gallery",
".product-gallery-wrapper",
".product-media-gallery",
".product-media-wrapper"
];
const HEADER_SELECTOR = [
".shopify-section-header-sticky",
"#shopify-section-header-sticky",
"#shopify-section-header",
".header-wrapper",
"header"
].join(",");
const CART_SELECTOR = [
"button[name='add']",
"input[name='add']",
".product-form__submit",
".product-form__buttons",
".shopify-payment-button",
"form[action*='/cart/add']",
"[data-add-to-cart]",
"button[aria-label*='add to cart' i]",
"button[title*='add to cart' i]",
"[class*='add-to-cart']",
"[class*='add_to_cart']",
"[class*='sticky'][class*='cart']",
"[class*='sticky'][class*='atc']",
"[class*='sticky'][class*='buy']",
"[class*='bottom'][class*='cart']"
].join(",");
const INTERACTION_SELECTOR = [
"#cl_optionsapp",
"variant-radios",
"variant-selects",
".product-form__input",
"[name^='options']"
].join(",");
/*
* Customily font and color controls are commonly div/button/label based
and
* do not always dispatch native input/change events.
*/
const VISUAL_CHOICE_SELECTOR = [
"#cl_optionsapp button",
"#cl_optionsapp [role='button']",
"#cl_optionsapp [role='option']",
"#cl_optionsapp label",
"#cl_optionsapp .swatch",
"#cl_optionsapp [class*='swatch']",
"#cl_optionsapp [class*='font']",
"#cl_optionsapp [class*='color']",
"#cl_optionsapp [data-value]"
].join(",");
const OBSERVED_ATTRIBUTES = [
"src",
"srcset",
"aria-hidden",
"aria-current",
"data-preview",
"data-active"
];
const state = {
mediaQuery: window.matchMedia(MOBILE_QUERY),
productRoot: null,
gallery: null,
sourceVisual: null,
sourceScore: -Infinity,
sourceSignature: "",
customilyLocked: false,
card: null,
viewport: null,
mirror: null,
mirrorSignature: "",
pendingSignature: "",
mirrorGeneration: 0,
naturalWidth: 1,
naturalHeight: 1,
startScroll: 0,
endScroll: Number.POSITIVE_INFINITY,
activeStartScroll: 0,
activeEndScroll: Number.POSITIVE_INFINITY,
active: false,
expanded: false,
leaving: false,
leaveTimer: 0,
refreshTimer: 0,
frameId: 0,
setupTimers: [],
postInputTimers: [],
pendingRefreshForce: false,
pendingRefreshRescan: false,
observedGallery: null,
observedParent: null,
observedSourceParent: null,
headerCandidates: [],
cartCandidates: [],
layoutCandidatesReady: false,
lastLayoutCheck: 0,
lastLayoutKey: "",
scanCount: 0,
mirrorUpdateCount: 0,
mutationBatchCount: 0,
lastVisualChoiceTarget: null,
lastVisualChoiceTime: 0,

nativePreviewMain: null,
nativePreviewHost: null,
nativePreviewDocked: false,
nativePreviewBackdrops: new Set(),
silentPreviewInitAttempts: 0,
silentPreviewInitTimer: 0,
silentPreviewInitClicking: false,
lastBridgeFailure: "",

nativePreviewOpenRequests: 0,
nativePreviewRestoreCount: 0,
nativePreviewButtonClickCount: 0
};
const observer = new MutationObserver(handleMutations);
function clamp(value, min, max) {
return Math.min(max, Math.max(min, value));
}
function nowTime() {
return window.performance && typeof window.performance.now ===
"function"
? window.performance.now()
: Date.now();
}
function uniqueElements(nodes) {
return Array.from(new Set(Array.from(nodes).filter(function (node) {
return node instanceof HTMLElement;
})));
}
function elementText(element) {
return String([
element && element.id,
element && element.className,
element && element.getAttribute && element.getAttribute("data-name"),
element && element.getAttribute && element.getAttribute("data-preview"),
element && element.getAttribute && element.getAttribute("aria-label"),
element && element.getAttribute && element.getAttribute("alt"),
element && element.getAttribute && element.getAttribute("title")
].filter(Boolean).join(" ")).toLowerCase();
}
function visualMetrics(element) {
if (!(element instanceof HTMLElement)) return null;
const rect = element.getBoundingClientRect();
if (rect.width < 24 || rect.height < 24) return null;
const style = window.getComputedStyle(element);
if (
style.display === "none" ||
style.visibility === "hidden" ||
Number(style.opacity) === 0
) {
return null;
}
return {
rect: rect,
area: rect.width * rect.height
};
}
function findProductRoot() {
return (
document.querySelector("main [id*='MainProduct']") ||
document.querySelector("main [data-section-type*='product']") ||
document.querySelector("main .product") ||
document.querySelector("main") ||
document.body
);
}
function galleryScore(element, root) {
if (!(element instanceof HTMLElement)) return -Infinity;
if (root !== document.body && !root.contains(element)) return -Infinity;
const rect = element.getBoundingClientRect();
if (rect.width < 220 || rect.height < 150) return -Infinity;
const text = elementText(element);
let score = rect.width * rect.height;
if (element.matches("[data-gtw-mobile-shrink-gallery]")) score +=
10000000;
if (element.tagName.toLowerCase() === "media-gallery") score += 800000;
if (text.includes("product")) score += 250000;
if (text.includes("gallery")) score += 220000;
if (text.includes("media")) score += 160000;
if (rect.top < window.innerHeight * 1.6) score += 180000;
return score;
}
function findGallery() {
const root = findProductRoot();
const candidates = [];
const seen = new Set();
for (const selector of GALLERY_SELECTORS) {
let nodes = [];
try {
nodes = document.querySelectorAll(selector);
} catch (_error) {
continue;
}
for (const node of nodes) {
if (
node instanceof HTMLElement &&
!seen.has(node) &&
node.querySelector("img,canvas,video,picture")
) {
seen.add(node);
candidates.push(node);
}
}
}
let best = null;
let bestScore = -Infinity;
for (const candidate of candidates) {
const score = galleryScore(candidate, root);
if (score > bestScore) {
best = candidate;
bestScore = score;
}
}
return best ? { root: root, gallery: best } : null;
}
function candidateDetails(element, gallery) {
if (
!(element instanceof HTMLElement) ||
!(gallery instanceof HTMLElement) ||
!gallery.contains(element)
) {
return null;
}
const metrics = visualMetrics(element);
if (!metrics) return null;
const rect = metrics.rect;
if (rect.width < 80 || rect.height < 80) return null;
const parent = element.parentElement;
const grandparent = parent && parent.parentElement;
const text =
elementText(element) + " " +
elementText(parent) + " " +
elementText(grandparent);
const tag = element.tagName.toLowerCase();
const source = element instanceof HTMLImageElement
? String(element.currentSrc || element.getAttribute("src") || "")
: "";
const activeOwner = element.closest(
".is-active,.active,[aria-hidden='false']," +
"[aria-current='true'],[data-active='true']"
);
const customily =
element instanceof HTMLCanvasElement ||
text.includes("customily") ||
text.includes("live preview") ||
element.matches("[data-gtw-customily-preview],[data-customily-preview]")
||
Boolean(
element.closest("[data-gtw-customily-preview],[data-customily-preview]")
) ||
source.startsWith("blob:") ||
source.startsWith("data:image") ||
source.toLowerCase().includes("customily");
let score = metrics.area;
if (activeOwner) score += 420000;
if (
element.matches("[data-gtw-customily-preview]") ||
element.closest("[data-gtw-customily-preview]")
) {
score += 5000000;
}
if (
element.matches("[data-customily-preview]") ||
element.closest("[data-customily-preview]")
) {
score += 3500000;
}
if (text.includes("customily")) score += 1800000;
if (text.includes("live preview")) score += 1250000;
else if (text.includes("preview")) score += 1000000;
if (tag === "canvas") score += 900000;
if (
source.startsWith("blob:") ||
source.startsWith("data:image") ||
source.toLowerCase().includes("customily")
) {
score += 650000;
}
if (
element.closest(
".thumbnail-slider,.thumbnail-list,.thumbnail," +
"[class*='thumbnail'],[data-thumbnail],[data-thumb]"
)
) {
score -= 3000000;
}
if (element.closest("[aria-hidden='true']")) score -= 900000;
return {
visual: element,
score: score,
customily: customily,
signature: sourceSignature(element)
};
}
function findNativePreviewCanvas() {
const canvas = document.querySelector(
NATIVE_PREVIEW_CANVAS_SELECTOR
);
if (
!(canvas instanceof HTMLCanvasElement) ||
!canvas.isConnected ||
canvas.width < 2 ||
canvas.height < 2
) {
return null;
}
return canvas;
}
function isNativePreviewSource(element) {
return (
element instanceof HTMLCanvasElement &&
element.isConnected &&
element.matches(NATIVE_PREVIEW_CANVAS_SELECTOR)
);
}
function nativePreviewCandidate() {
const canvas = findNativePreviewCanvas();
if (!canvas) return null;
return {
visual: canvas,
score: 25000000,
customily: true,
nativePreview: true,
signature: sourceSignature(canvas)
};
}
function nativePreviewMainFromCanvas(canvas) {
if (!(canvas instanceof HTMLCanvasElement)) return null;

return (
canvas.closest(".main") ||
canvas.closest("[role='dialog']") ||
canvas.closest("[class*='modal']") ||
canvas.parentElement
);
}

function nativePreviewHostFromMain(main) {
if (!(main instanceof HTMLElement)) return null;

let current = main;
let best = main;
let depth = 0;

while (
current instanceof HTMLElement &&
current !== document.body &&
depth < 12
) {
const style = window.getComputedStyle(current);
const signature = String([
current.id,
current.className,
current.getAttribute("role"),
current.getAttribute("aria-modal")
].filter(Boolean).join(" ")).toLowerCase();

const modalLike =
current.getAttribute("role") === "dialog" ||
current.getAttribute("aria-modal") === "true" ||
style.position === "fixed" ||
signature.includes("modal") ||
signature.includes("popup") ||
signature.includes("preview") ||
signature.includes("customily");

if (modalLike) best = current;

current = current.parentElement;
depth += 1;
}

return best;
}

function viewportOverlay(element) {
if (
!(element instanceof HTMLElement) ||
element === document.body ||
element === document.documentElement ||
element === state.card ||
element.contains(state.card)
) {
return false;
}

const style = window.getComputedStyle(element);

if (
style.position !== "fixed" &&
style.position !== "absolute"
) {
return false;
}

const rect = element.getBoundingClientRect();
const viewportWidth =
document.documentElement.clientWidth ||
window.innerWidth;
const viewportHeight = window.visualViewport
? window.visualViewport.height
: window.innerHeight;

if (
rect.width < viewportWidth * 0.72 ||
rect.height < viewportHeight * 0.72
) {
return false;
}

const signature = String([
element.id,
element.className,
element.getAttribute("role"),
element.getAttribute("aria-modal")
].filter(Boolean).join(" ")).toLowerCase();

const z = Number.parseInt(style.zIndex, 10);

return (
signature.includes("modal") ||
signature.includes("overlay") ||
signature.includes("backdrop") ||
signature.includes("popup") ||
signature.includes("preview") ||
signature.includes("customily") ||
(Number.isFinite(z) && z >= 1000)
);
}

function clearDockedBackdrops() {
for (const element of state.nativePreviewBackdrops) {
if (element instanceof HTMLElement) {
element.classList.remove(
"gtw-native-preview-backdrop-docked"
);
}
}

state.nativePreviewBackdrops.clear();
}

function dockNativePreviewForMirror() {
const canvas = findNativePreviewCanvas();

if (!(canvas instanceof HTMLCanvasElement)) {
state.lastBridgeFailure =
"native-preview-canvas-not-found";
return false;
}

const main = nativePreviewMainFromCanvas(canvas);
const host = nativePreviewHostFromMain(main);

if (
!(main instanceof HTMLElement) ||
!(host instanceof HTMLElement)
) {
state.lastBridgeFailure =
"native-preview-modal-host-not-found";
return false;
}

state.nativePreviewMain = main;
state.nativePreviewHost = host;
state.nativePreviewDocked = true;
state.lastBridgeFailure = "";

main.classList.add(
"gtw-native-preview-main-docked"
);

host.classList.add(
"gtw-native-preview-host-docked"
);

clearDockedBackdrops();

for (const child of document.body.children) {
if (
!(child instanceof HTMLElement) ||
child === host ||
child.contains(main) ||
host.contains(child)
) {
continue;
}

if (viewportOverlay(child)) {
child.classList.add(
"gtw-native-preview-backdrop-docked"
);
state.nativePreviewBackdrops.add(child);
}
}

document.documentElement.classList.remove(
"gtw-native-preview-silent-opening"
);

document.documentElement.classList.add(
"gtw-native-preview-mirror-ready"
);

return true;
}

function showDockedNativePreview() {
const host = state.nativePreviewHost;
const main = state.nativePreviewMain;

const genuinelyDocked =
state.nativePreviewDocked ||
(
host instanceof HTMLElement &&
host.classList.contains(
"gtw-native-preview-host-docked"
)
) ||
(
main instanceof HTMLElement &&
main.classList.contains(
"gtw-native-preview-main-docked"
)
);

if (!genuinelyDocked) {
return false;
}

if (
!(host instanceof HTMLElement) ||
!host.isConnected ||
!(main instanceof HTMLElement) ||
!main.isConnected
) {
state.nativePreviewDocked = false;
return false;
}

host.classList.remove(
"gtw-native-preview-host-docked"
);

main.classList.remove(
"gtw-native-preview-main-docked"
);

clearDockedBackdrops();

document.documentElement.classList.remove(
"gtw-native-preview-mirror-ready",
"gtw-native-preview-silent-opening"
);

state.nativePreviewDocked = false;

return true;
}

function scheduleSilentPreviewCapture(delay) {
if (state.silentPreviewInitTimer) {
window.clearTimeout(
state.silentPreviewInitTimer
);
}

state.silentPreviewInitTimer =
window.setTimeout(function () {
state.silentPreviewInitTimer = 0;

if (dockNativePreviewForMirror()) {
schedulePreviewRefresh(
0,
true,
true
);
return;
}

if (state.silentPreviewInitAttempts < 4) {
scheduleSilentPreviewCapture(220);
}
}, typeof delay === "number" ? delay : 30);
}

function silentlyCreateNativePreview() {
if (
findNativePreviewCanvas() ||
state.silentPreviewInitAttempts >= 4
) {
return false;
}

const button = findNativePreviewButton();

if (!button) {
state.lastBridgeFailure =
"native-preview-button-not-found";
return false;
}

state.silentPreviewInitAttempts += 1;
state.silentPreviewInitClicking = true;

document.documentElement.classList.add(
"gtw-native-preview-silent-opening"
);

button.click();

state.silentPreviewInitClicking = false;

scheduleSilentPreviewCapture(20);

return true;
}

function findNativePreviewButton() {
const direct = document.querySelector(
NATIVE_PREVIEW_BUTTON_SELECTOR
);
if (
direct instanceof HTMLButtonElement &&
!direct.disabled
) {
return direct;
}
const candidates = document.querySelectorAll(
".sticky-btn-container button,button"
);
for (const button of candidates) {
if (
button instanceof HTMLButtonElement &&
button !== state.card &&
!button.disabled &&
/\bpreview\b/i.test(button.textContent || "")
) {
return button;
}
}
return null;
}
function openNativeCustomilyPreview() {
state.nativePreviewOpenRequests += 1;

if (showDockedNativePreview()) {
state.nativePreviewRestoreCount += 1;
schedulePostInputRefreshes(true);
return true;
}

const button = findNativePreviewButton();

if (!button) {
state.lastBridgeFailure =
"native-preview-button-not-found-on-open";
return false;
}

state.nativePreviewButtonClickCount += 1;

button.click();
schedulePostInputRefreshes(true);
return true;
}
function sourceSignature(element) {
if (element instanceof HTMLImageElement) {
return "img|" + String(
element.currentSrc ||
element.getAttribute("src") ||
""
);
}
if (element instanceof HTMLCanvasElement) {
return "canvas|" + element.width + "x" + element.height;
}
if (element instanceof HTMLVideoElement) {
return "video|" +
String(element.currentSrc || element.getAttribute("src") || "") +
"|" + element.videoWidth + "x" + element.videoHeight;
}
return "";
}
function findPreviewCandidate(gallery) {
state.scanCount += 1;

const nativeCandidate = nativePreviewCandidate();

if (nativeCandidate) {
return nativeCandidate;
}

/*
* GolfSignet uses Customily Modal Preview.
* The gallery is retained only for visibility timing and never
* becomes the card's image source.
*/
return null;
}
function ensureCard() {
if (state.card && state.card.isConnected) return;
const card = document.createElement("button");
card.type = "button";
card.className = "gtw-live-preview-card";
card.setAttribute("aria-label", "Open full Customily preview");
card.setAttribute("aria-expanded", "false");
card.setAttribute("aria-haspopup", "dialog");
card.innerHTML = [
'<span class="gtw-live-preview-viewport"></span>',
'<span class="gtw-live-preview-footer">',
' <span class="gtw-live-preview-label">',
' <span class="gtw-live-preview-dot" aria-hidden="true"></span>',
' <span class="gtw-live-preview-live">LIVE</span>',
' <span class="gtw-live-preview-word">PREVIEW</span>',
' </span>',
' <span class="gtw-live-preview-action" aria-hidden="true">',
' <span class="gtw-live-preview-action__expand">↗</span>',
' <span class="gtw-live-preview-action__close">CLOSE</span>',
' </span>',
'</span>'
].join("");
card.addEventListener("click", function () {
if (!state.active) return;
state.expanded = false;
openNativeCustomilyPreview();
});
document.body.appendChild(card);
state.card = card;
state.viewport = card.querySelector(".gtw-live-preview-viewport");
}
function sourceIntrinsic(element) {
let width = 0;
let height = 0;
if (element instanceof HTMLImageElement) {
width = element.naturalWidth;
height = element.naturalHeight;
} else if (element instanceof HTMLCanvasElement) {
width = element.width;
height = element.height;
} else if (element instanceof HTMLVideoElement) {
width = element.videoWidth;
height = element.videoHeight;
}
const rect = element.getBoundingClientRect();
return {
width: Math.max(1, Math.round(width || rect.width || 1)),
height: Math.max(1, Math.round(height || rect.height || 1))
};
}
function rasterMirrorDimensions(sourceWidth, sourceHeight) {
const width = Math.max(1, Number(sourceWidth) || 1);
const height = Math.max(1, Number(sourceHeight) || 1);
const pixelRatio = clamp(window.devicePixelRatio || 1, 1, 2);
const maxEdge = Math.round(MIRROR_MAX_CSS_EDGE * pixelRatio);
const scale = Math.min(1, maxEdge / Math.max(width, height));
return {
width: Math.max(1, Math.round(width * scale)),
height: Math.max(1, Math.round(height * scale)),
sourceWidth: width,
sourceHeight: height
};
}
function commitMirror(nextMirror, signature, width, height) {
if (!(nextMirror instanceof HTMLElement) || !state.viewport) {
return false;
}
const previous = state.mirror;
nextMirror.classList.add("gtw-live-preview-mirror");
state.viewport.appendChild(nextMirror);
state.mirror = nextMirror;
state.mirrorSignature = signature;
state.pendingSignature = "";
state.naturalWidth = Math.max(1, width || 1);
state.naturalHeight = Math.max(1, height || 1);
state.mirrorUpdateCount += 1;
state.lastLayoutKey = "";
if (previous && previous !== nextMirror) {
window.requestAnimationFrame(function () {
if (previous.parentNode) previous.remove();
});
}
applyCardLayout(true);
return true;
}
function updateImageMirror(sourceImage, signature) {
const source = String(
sourceImage.currentSrc ||
sourceImage.getAttribute("src") ||
""
);
if (!source) return false;
if (
signature === state.mirrorSignature ||
signature === state.pendingSignature
) {
return true;
}
state.pendingSignature = signature;
const generation = ++state.mirrorGeneration;
const nextImage = new Image();
nextImage.alt = "";
nextImage.decoding = "async";
nextImage.loading = "eager";
nextImage.draggable = false;
const commit = function () {
if (
generation !== state.mirrorGeneration ||
signature !== state.pendingSignature
) {
return;
}
commitMirror(
nextImage,
signature,
nextImage.naturalWidth || sourceImage.naturalWidth,
nextImage.naturalHeight || sourceImage.naturalHeight
);
};
const fail = function () {
if (generation === state.mirrorGeneration) {
state.pendingSignature = "";
}
};
nextImage.addEventListener("load", function () {
if (typeof nextImage.decode === "function") {
nextImage.decode().then(commit).catch(commit);
} else {
commit();
}
}, { once: true });
nextImage.addEventListener("error", fail, { once: true });
nextImage.src = source;
if (nextImage.complete && nextImage.naturalWidth > 0) {
if (typeof nextImage.decode === "function") {
nextImage.decode().then(commit).catch(commit);
} else {
commit();
}
}
return true;
}
function updateCanvasMirror(sourceCanvas, signature) {
let mirror = state.mirror;
if (!(mirror instanceof HTMLCanvasElement)) {
mirror = document.createElement("canvas");
}
const sourceWidth = Math.max(1, sourceCanvas.width);
const sourceHeight = Math.max(1, sourceCanvas.height);
const raster = rasterMirrorDimensions(sourceWidth, sourceHeight);
if (mirror.width !== raster.width) {
mirror.width = raster.width;
}
if (mirror.height !== raster.height) {
mirror.height = raster.height;
}
const context = mirror.getContext("2d", { alpha: true });
if (!context) return false;
try {
context.clearRect(0, 0, raster.width, raster.height);
context.drawImage(
sourceCanvas,
0,
0,
sourceWidth,
sourceHeight,
0,
0,
raster.width,
raster.height
);
} catch (_error) {
return false;
}
if (state.mirror !== mirror) {
return commitMirror(
mirror,
signature,
raster.sourceWidth,
raster.sourceHeight
);
}
state.mirrorSignature = signature;
state.naturalWidth = raster.sourceWidth;
state.naturalHeight = raster.sourceHeight;
state.mirrorUpdateCount += 1;
state.lastLayoutKey = "";
applyCardLayout(true);
return true;
}
function updateVideoMirror(sourceVideo, signature) {
const mirror = state.mirror instanceof HTMLCanvasElement
? state.mirror
: document.createElement("canvas");
const rect = sourceVideo.getBoundingClientRect();
const sourceWidth = Math.max(
1,
sourceVideo.videoWidth || rect.width
);
const sourceHeight = Math.max(
1,
sourceVideo.videoHeight || rect.height
);
const raster = rasterMirrorDimensions(
sourceWidth,
sourceHeight
);
mirror.width = raster.width;
mirror.height = raster.height;
const context = mirror.getContext("2d", { alpha: true });
if (!context) return false;
try {
context.drawImage(
sourceVideo,
0,
0,
sourceWidth,
sourceHeight,
0,
0,
raster.width,
raster.height
);
} catch (_error) {
return false;
}
if (state.mirror !== mirror) {
return commitMirror(
mirror,
signature,
raster.sourceWidth,
raster.sourceHeight
);
}
state.mirrorSignature = signature;
state.naturalWidth = raster.sourceWidth;
state.naturalHeight = raster.sourceHeight;
state.mirrorUpdateCount += 1;
state.lastLayoutKey = "";
applyCardLayout(true);
return true;
}
function updateMirrorFromSource(forceRasterRefresh) {
const visual = state.sourceVisual;
if (!(visual instanceof HTMLElement)) return false;
const signature = sourceSignature(visual);
if (visual instanceof HTMLImageElement) {
return updateImageMirror(visual, signature);
}
if (visual instanceof HTMLCanvasElement) {
if (
!forceRasterRefresh &&
signature === state.mirrorSignature &&
state.mirror instanceof HTMLCanvasElement
) {
return true;
}
return updateCanvasMirror(visual, signature);
}
if (visual instanceof HTMLVideoElement) {
if (
!forceRasterRefresh &&
signature === state.mirrorSignature
) {
return true;
}
return updateVideoMirror(visual, signature);
}
return false;
}
function selectCandidate(candidate) {
if (!candidate || !(candidate.visual instanceof HTMLElement)) {
return false;
}
state.sourceVisual = candidate.visual;
state.sourceScore = candidate.score;
state.sourceSignature = candidate.signature;
if (candidate.customily) {
state.customilyLocked = true;
}
const size = sourceIntrinsic(candidate.visual);
state.naturalWidth = size.width;
state.naturalHeight = size.height;
return updateMirrorFromSource(true);
}
function refreshCurrentSource(forceRasterRefresh) {
const visual = state.sourceVisual;
const sourceIsUsable =
visual instanceof HTMLElement &&
visual.isConnected &&
(
isNativePreviewSource(visual) ||
(
state.gallery instanceof HTMLElement &&
state.gallery.contains(visual)
)
);
if (!sourceIsUsable) {
return false;
}
const nextSignature = sourceSignature(visual);
const changed =
nextSignature &&
nextSignature !== state.sourceSignature;
state.sourceSignature = nextSignature;
if (
changed ||
(
forceRasterRefresh &&
(
visual instanceof HTMLCanvasElement ||
visual instanceof HTMLVideoElement
)
)
) {
updateMirrorFromSource(Boolean(forceRasterRefresh));
}
return true;
}
function refreshPreviewReference(forceRasterRefresh, rescan) {
if (!state.mediaQuery.matches || document.hidden) return false;
if (!state.gallery || !state.gallery.isConnected) {
const found = findGallery();
if (!found) return false;
state.productRoot = found.root;
state.gallery = found.gallery;
if (state.active) {
startObserver(found.gallery);
}
collectLayoutCandidates();
rescan = true;
}
if (!rescan && refreshCurrentSource(forceRasterRefresh)) {
return true;
}
const candidate = findPreviewCandidate(state.gallery);
if (!candidate) {
return refreshCurrentSource(forceRasterRefresh);
}
if (!(state.sourceVisual instanceof HTMLElement)) {
selectCandidate(candidate);
measurePageRange();
requestRender();
return true;
}
if (candidate.visual === state.sourceVisual) {
const changed =
candidate.signature &&
candidate.signature !== state.sourceSignature;
state.sourceScore = candidate.score;
state.sourceSignature = candidate.signature;
if (candidate.customily) {
state.customilyLocked = true;
}
if (
changed ||
(
forceRasterRefresh &&
(
candidate.visual instanceof HTMLCanvasElement ||
candidate.visual instanceof HTMLVideoElement
)
)
) {
updateMirrorFromSource(Boolean(forceRasterRefresh));
}
return true;
}
const currentConnected =
state.sourceVisual.isConnected &&
(
isNativePreviewSource(state.sourceVisual) ||
(
state.gallery instanceof HTMLElement &&
state.gallery.contains(state.sourceVisual)
)
);
const materiallyBetter =
candidate.score > state.sourceScore + 160000;
const shouldSwitch =
!currentConnected ||
candidate.customily ||
materiallyBetter;
if (shouldSwitch) {
selectCandidate(candidate);
} else if (forceRasterRefresh) {
refreshCurrentSource(true);
}
return true;
}
function schedulePreviewRefresh(delay, forceRasterRefresh, rescan) {
state.pendingRefreshForce =
state.pendingRefreshForce || Boolean(forceRasterRefresh);
state.pendingRefreshRescan =
state.pendingRefreshRescan || Boolean(rescan);
if (state.refreshTimer) {
window.clearTimeout(state.refreshTimer);
}
state.refreshTimer = window.setTimeout(function () {
const force = state.pendingRefreshForce;
const scan = state.pendingRefreshRescan;
state.refreshTimer = 0;
state.pendingRefreshForce = false;
state.pendingRefreshRescan = false;
refreshPreviewReference(force, scan);
}, typeof delay === "number" ? delay : 60);
}
function clearPostInputTimers() {
for (const timer of state.postInputTimers) {
window.clearTimeout(timer);
}
state.postInputTimers = [];
}
function schedulePostInputRefreshes(forceFinalRaster) {
clearPostInputTimers();
const interactionMirrorCount = state.mirrorUpdateCount;
const schedule = forceFinalRaster
? [
{
delay: 90,
force: false,
rescan: false,
fallbackOnly: false
},
{
delay: 360,
force: true,
rescan: true,
fallbackOnly: false
},
{
/*
* Fonts may finish rendering after the Customily click handler and
* after the first canvas redraw. This one finite late copy ensures
* the final glyph/color pixels reach the card.
*/
delay: 1050,
force: true,
rescan: false,
fallbackOnly: false
}
]
: [
{
delay: 80,
force: false,
rescan: false,
fallbackOnly: false
},
{
delay: 270,
force: true,
rescan: true,
fallbackOnly: false
},
{
delay: 680,
force: true,
rescan: false,
fallbackOnly: true
}
];
schedule.forEach(function (item) {
const timer = window.setTimeout(function () {
if (
item.fallbackOnly &&
state.mirrorUpdateCount > interactionMirrorCount
) {
return;
}
refreshPreviewReference(item.force, item.rescan);
}, item.delay);
state.postInputTimers.push(timer);
});
}
function mutationImpact(record) {
const target = record.target instanceof Element
? record.target
: null;
if (record.type === "attributes" && target) {
if (target === state.sourceVisual) {
const activeStateChange =
record.attributeName === "aria-hidden" ||
record.attributeName === "aria-current" ||
record.attributeName === "data-active" ||
record.attributeName === "data-preview";
return {
relevant: true,
force: false,
rescan: activeStateChange
};
}
if (
target.matches("img,canvas,video") ||
target.closest(
".is-active,.active,[aria-hidden]," +
"[aria-current],[data-active],[data-preview]"
)
) {
return {
relevant: true,
force: false,
rescan: true
};
}
return {
relevant: false,
force: false,
rescan: false
};
}
if (record.type === "childList") {
if (
record.target === state.observedParent ||
record.target === state.observedSourceParent
) {
return {
relevant: true,
force: false,
rescan: true
};
}
if (
state.sourceVisual &&
!state.sourceVisual.isConnected
) {
return {
relevant: true,
force: false,
rescan: true
};
}
const changedNodes = [
...record.addedNodes,
...record.removedNodes
];
for (const node of changedNodes) {
if (!(node instanceof Element)) continue;
if (
node.matches(
"img,canvas,video,[data-customily-preview]," +
"[data-gtw-customily-preview],[class*='customily']"
) ||
node.querySelector(
"img,canvas,video,[data-customily-preview]," +
"[data-gtw-customily-preview],[class*='customily']"
)
) {
return {
relevant: true,
force: false,
rescan: true
};
}
}
}
return {
relevant: false,
force: false,
rescan: false
};
}
function handleMutations(records) {
if (
document.hidden ||
!state.mediaQuery.matches ||
!state.active
) {
return;
}
state.mutationBatchCount += 1;
let relevant = false;
let forceRasterRefresh = false;
let rescan = false;
for (const record of records) {
const impact = mutationImpact(record);
if (!impact.relevant) continue;
relevant = true;
forceRasterRefresh =
forceRasterRefresh || impact.force;
rescan =
rescan || impact.rescan;
}
if (relevant) {
schedulePreviewRefresh(
90,
forceRasterRefresh,
rescan
);
}
}
function stopObserver() {
observer.disconnect();
state.observedGallery = null;
state.observedParent = null;
state.observedSourceParent = null;
}
function startObserver(gallery) {
if (!(gallery instanceof HTMLElement) || document.hidden) return;
const parent = gallery.parentElement;
const nativeCanvas = findNativePreviewCanvas();
const sourceParent =
nativeCanvas instanceof HTMLCanvasElement
? nativeCanvas.parentElement
: null;
if (
state.observedGallery === gallery &&
state.observedParent === parent &&
state.observedSourceParent === sourceParent
) {
return;
}
stopObserver();
observer.observe(gallery, {
childList: true,
subtree: true,
attributes: true,
attributeFilter: OBSERVED_ATTRIBUTES
});
if (parent) {
observer.observe(parent, {
childList: true,
subtree: false
});
}
if (
sourceParent instanceof HTMLElement &&
sourceParent !== gallery &&
sourceParent !== parent
) {
observer.observe(sourceParent, {
childList: true,
subtree: true,
attributes: true,
attributeFilter: OBSERVED_ATTRIBUTES
});
}
state.observedGallery = gallery;
state.observedParent = parent;
state.observedSourceParent = sourceParent;
}
function collectLayoutCandidates() {
state.headerCandidates = uniqueElements(
document.querySelectorAll(HEADER_SELECTOR)
);
state.cartCandidates = uniqueElements(
document.querySelectorAll(CART_SELECTOR)
);
state.layoutCandidatesReady = true;
state.lastLayoutKey = "";
}
function isRenderedForLayout(element) {
if (!(element instanceof HTMLElement)) return false;
const rect = element.getBoundingClientRect();
if (rect.width <= 0 || rect.height <= 0) return false;
const style = window.getComputedStyle(element);
return (
style.display !== "none" &&
style.visibility !== "hidden" &&
Number(style.opacity) !== 0
);
}
function detectStickyHeaderBottom() {
let bottom = 0;
for (const element of state.headerCandidates) {
if (!(element instanceof HTMLElement) || !element.isConnected) continue;
const style = window.getComputedStyle(element);
if (
style.position !== "sticky" &&
style.position !== "fixed"
) {
continue;
}
const rect = element.getBoundingClientRect();
if (
rect.height > 0 &&
rect.bottom > 0 &&
rect.top <= 14
) {
bottom = Math.max(bottom, rect.bottom);
}
}
return Math.round(clamp(bottom, 0, 190));
}
function fixedOrStickyOwner(element) {
let current = element;
let depth = 0;
while (current instanceof HTMLElement && depth < 10) {
const style = window.getComputedStyle(current);
if (
style.position === "fixed" ||
style.position === "sticky"
) {
return current;
}
current = current.parentElement;
depth += 1;
}
return null;
}
function detectStickyCartTop(viewportHeight) {
let top = viewportHeight;
const visited = new Set();
for (const candidate of state.cartCandidates) {
if (!(candidate instanceof HTMLElement) || !candidate.isConnected) {
continue;
}
const owner = fixedOrStickyOwner(candidate);
if (
!(owner instanceof HTMLElement) ||
visited.has(owner) ||
!isRenderedForLayout(owner)
) {
continue;
}
visited.add(owner);
const rect = owner.getBoundingClientRect();
const nearBottom = rect.bottom >= viewportHeight - 32;
const insideViewport =
rect.top > 0 &&
rect.top < viewportHeight;
if (nearBottom && insideViewport) {
top = Math.min(top, rect.top);
}
}
return Math.round(top);
}
function applyCardLayout(force) {
if (!state.active || !state.card) return;
const currentTime = nowTime();
if (
!force &&
currentTime - state.lastLayoutCheck < LAYOUT_CHECK_INTERVAL
) {
return;
}
state.lastLayoutCheck = currentTime;
if (!state.layoutCandidatesReady) {
collectLayoutCandidates();
}
const viewportWidth =
document.documentElement.clientWidth ||
window.innerWidth;
const viewportHeight = window.visualViewport
? window.visualViewport.height
: window.innerHeight;
const headerBottom = detectStickyHeaderBottom();
const cardTop = Math.round(
Math.max(
headerBottom + 48,
112
)
);
const cardRight = 2;
const detectedCartTop = detectStickyCartTop(viewportHeight);
const safeBottomTop = Math.min(
detectedCartTop - 18,
viewportHeight - 94
);
const availableHeight = Math.max(
112,
safeBottomTop - cardTop
);
const aspect = clamp(
state.naturalWidth / state.naturalHeight,
0.52,
1.9
);
const footerHeight = state.expanded ? 31 : 27;
let cardWidth;
let previewHeight;
let radius;
let mediaScale;
if (state.expanded) {
cardWidth = Math.round(
clamp(viewportWidth * 0.49, 168, 202)
);
previewHeight = Math.round(cardWidth / aspect);
previewHeight = clamp(previewHeight, 148, 224);
previewHeight = Math.min(
previewHeight,
Math.max(100, availableHeight - footerHeight)
);
cardWidth = Math.min(
cardWidth,
Math.round(previewHeight * aspect),
viewportWidth - 14
);
cardWidth = Math.max(152, cardWidth);
radius = 15;
mediaScale = 1.13;
} else {
cardWidth = Math.round(
clamp(viewportWidth * 0.205, 74, 84)
);
previewHeight = Math.round(cardWidth / aspect);
previewHeight = clamp(previewHeight, 82, 106);
previewHeight = Math.min(
previewHeight,
Math.max(70, availableHeight - footerHeight)
);
radius = 13;
mediaScale = 1.09;
}
const layoutKey = [
cardTop,
cardRight,
cardWidth,
previewHeight,
footerHeight,
radius,
availableHeight,
mediaScale,
state.expanded ? 1 : 0
].join("|");
if (layoutKey === state.lastLayoutKey) return;
state.lastLayoutKey = layoutKey;
state.card.style.setProperty(
"--gtw-live-card-top",
cardTop + "px"
);
state.card.style.setProperty(
"--gtw-live-card-right",
cardRight + "px"
);
state.card.style.setProperty(
"--gtw-live-card-width",
cardWidth + "px"
);
state.card.style.setProperty(
"--gtw-live-preview-height",
previewHeight + "px"
);
state.card.style.setProperty(
"--gtw-live-footer-height",
footerHeight + "px"
);
state.card.style.setProperty(
"--gtw-live-card-radius",
radius + "px"
);
state.card.style.setProperty(
"--gtw-live-card-max-height",
availableHeight + "px"
);
state.card.style.setProperty(
"--gtw-live-media-scale",
String(mediaScale)
);
state.card.classList.toggle(
"is-expanded",
state.expanded
);
state.card.setAttribute(
"aria-expanded",
String(state.expanded)
);
state.card.setAttribute(
"aria-label",
"Open full Customily preview"
);
}
function measurePageRange() {
if (!state.gallery || !state.productRoot) return false;
const galleryRect = state.gallery.getBoundingClientRect();
if (
galleryRect.width < 220 ||
galleryRect.height < 150
) {
return false;
}
if (!state.layoutCandidatesReady) {
collectLayoutCandidates();
}
const pageY = window.scrollY || window.pageYOffset || 0;
const headerBottom = detectStickyHeaderBottom();
const galleryBottomPage = pageY + galleryRect.bottom;
state.startScroll = Math.max(
0,
galleryBottomPage - headerBottom - 18
);
const productRect = state.productRoot.getBoundingClientRect();
const productBottomPage = pageY + productRect.bottom;
state.endScroll = Math.max(
state.startScroll + 220,
productBottomPage - headerBottom - 120
);
return true;
}
function clearLeaveTimer() {
if (!state.leaveTimer) return;
window.clearTimeout(state.leaveTimer);
state.leaveTimer = 0;
}
function cancelLeaving() {
if (!state.leaving || !state.card) return;
clearLeaveTimer();
state.leaving = false;
state.card.classList.remove("is-leaving");
state.card.classList.add("is-visible");
applyCardLayout(true);
}
function finalizeDeactivate() {
clearLeaveTimer();
state.active = false;
state.leaving = false;
state.expanded = false;
state.activeStartScroll = 0;
state.activeEndScroll = Number.POSITIVE_INFINITY;
state.lastLayoutKey = "";
stopObserver();
clearPostInputTimers();
clearRefreshTimer();
if (state.card) {
state.card.classList.remove(
"is-visible",
"is-leaving",
"is-expanded"
);
state.card.setAttribute("aria-expanded", "false");
}
document.documentElement.classList.remove(
"gtw-live-preview-card-active"
);
}
function activate() {
if (!state.card || !state.viewport || !state.mirror) return;
if (state.leaving) {
cancelLeaving();
return;
}
if (state.active) return;
state.active = true;
state.activeStartScroll = state.startScroll;
state.activeEndScroll = state.endScroll;
state.lastLayoutKey = "";
collectLayoutCandidates();
startObserver(state.gallery);
/*
* Recheck once on activation in case Customily changed while the card
was
* outside its visible scroll range.
*/
refreshPreviewReference(true, true);
state.card.classList.remove("is-leaving");
state.card.classList.add("is-visible");
document.documentElement.classList.add(
"gtw-live-preview-card-active"
);
applyCardLayout(true);
}
function deactivate(immediate) {
if (!state.active) return;
if (immediate) {
finalizeDeactivate();
return;
}
if (state.leaving || !state.card) return;
state.leaving = true;
state.card.classList.remove("is-visible");
state.card.classList.add("is-leaving");
clearLeaveTimer();
state.leaveTimer = window.setTimeout(
finalizeDeactivate,
250
);
}
function render() {
state.frameId = 0;
if (
!state.mediaQuery.matches ||
!state.gallery ||
!state.sourceVisual ||
!state.mirror
) {
deactivate(true);
return;
}
const y = window.scrollY || window.pageYOffset || 0;
if (state.active) {
const aboveReturnPoint =
y < state.activeStartScroll - 42;
const belowProduct =
y > state.activeEndScroll + 80;
const shouldStay =
!aboveReturnPoint &&
!belowProduct;
if (shouldStay && state.leaving) {
cancelLeaving();
} else if (!shouldStay && !state.leaving) {
deactivate(false);
} else if (shouldStay) {
/*
* This call is throttled and writes nothing unless the calculated
* layout actually changed.
*/
applyCardLayout(false);
}
return;
}
if (
y >= state.startScroll &&
y <= state.endScroll
) {
activate();
}
}
function requestRender() {
if (state.frameId) return;
state.frameId = window.requestAnimationFrame(render);
}
function clearSetupTimers() {
for (const timer of state.setupTimers) {
window.clearTimeout(timer);
}
state.setupTimers = [];
}
function clearRefreshTimer() {
if (state.refreshTimer) {
window.clearTimeout(state.refreshTimer);
state.refreshTimer = 0;
}
state.pendingRefreshForce = false;
state.pendingRefreshRescan = false;
}
function setup() {
if (!state.mediaQuery.matches || document.hidden) {
return false;
}

ensureCard();

if (!state.gallery || !state.gallery.isConnected) {
const found = findGallery();

if (!found) return false;

state.productRoot = found.root;
state.gallery = found.gallery;
state.layoutCandidatesReady = false;
}

if (!measurePageRange()) return false;

const candidate = findPreviewCandidate(
state.gallery
);

if (!candidate) {
silentlyCreateNativePreview();
requestRender();
return false;
}

selectCandidate(candidate);
clearSetupTimers();
requestRender();

return true;
}
function scheduleSetupRetries() {
clearSetupTimers();
[0, 500, 1500, 3200].forEach(function (delay) {
const timer = window.setTimeout(function () {
if (setup()) {
clearSetupTimers();
}
}, delay);
state.setupTimers.push(timer);
});
}
function suspend() {
if (state.silentPreviewInitTimer) {
window.clearTimeout(
state.silentPreviewInitTimer
);
state.silentPreviewInitTimer = 0;
}

stopObserver();
clearSetupTimers();
clearPostInputTimers();
clearRefreshTimer();
if (state.frameId) {
window.cancelAnimationFrame(state.frameId);
state.frameId = 0;
}
deactivate(true);
}
function handleViewportChange() {
if (!state.mediaQuery.matches) {
suspend();
return;
}
state.layoutCandidatesReady = false;
collectLayoutCandidates();
if (state.active) {
applyCardLayout(true);
} else if (state.gallery && state.gallery.isConnected) {
measurePageRange();
requestRender();
} else {
scheduleSetupRetries();
}
}

function handleNativePreviewButtonIntent(event) {
const target = event.target instanceof Element
? event.target
: event.target && event.target.parentElement;

if (!(target instanceof Element)) return;

const button = target.closest(
NATIVE_PREVIEW_BUTTON_SELECTOR
);

if (
!(button instanceof HTMLButtonElement) ||
button === state.card
) {
return;
}

if (state.silentPreviewInitClicking) {
return;
}

/*
* Do not preventDefault, stopPropagation or stopImmediatePropagation.
* The original Customily Preview button remains fully native.
*/
showDockedNativePreview();

window.setTimeout(function () {
const canvas = findNativePreviewCanvas();

if (canvas) {
state.nativePreviewMain =
nativePreviewMainFromCanvas(canvas);
state.nativePreviewHost =
nativePreviewHostFromMain(
state.nativePreviewMain
);
schedulePostInputRefreshes(true);
}
}, 40);
}

function handleRelevantInteraction(event) {
const target = event.target instanceof Element
? event.target
: event.target && event.target.parentElement;
if (
target &&
target.closest(INTERACTION_SELECTOR)
) {
if (state.active && state.gallery) {
startObserver(state.gallery);
}
schedulePostInputRefreshes(false);
}
}
function handleVisualChoiceInteraction(event) {
const target = event.target instanceof Element
? event.target
: event.target && event.target.parentElement;
if (!(target instanceof Element)) return;
const choice = target.closest(VISUAL_CHOICE_SELECTOR);
if (!(choice instanceof Element)) return;
/*
* Clicking into a text field is already handled by the input listener
and
* should not start the slower font/color synchronization schedule.
*/
if (
choice.matches("input[type='text'],textarea") ||
choice.closest("input[type='text'],textarea")
) {
return;
}
const currentTime = nowTime();
if (
state.lastVisualChoiceTarget === choice &&
currentTime - state.lastVisualChoiceTime < 180
) {
return;
}
state.lastVisualChoiceTarget = choice;
state.lastVisualChoiceTime = currentTime;
if (state.active && state.gallery) {
startObserver(state.gallery);
}
schedulePostInputRefreshes(true);
}
window.GTWTowelPreviewStatus = function () {
return {
build: BUILD,
mobile: state.mediaQuery.matches,
galleryFound: Boolean(
state.gallery &&
state.gallery.isConnected
),
sourceFound: Boolean(
state.sourceVisual &&
state.sourceVisual.isConnected
),
sourceTag: state.sourceVisual
? state.sourceVisual.tagName
: null,
sourceOrigin: isNativePreviewSource(state.sourceVisual)
? "customily-native-preview-canvas"
: "shopify-gallery",
nativePreviewButtonFound: Boolean(
findNativePreviewButton()
),
nativePreviewCanvasFound: Boolean(
findNativePreviewCanvas()
),
nativePreviewDocked:
state.nativePreviewDocked,
nativePreviewHostFound: Boolean(
state.nativePreviewHost &&
state.nativePreviewHost.isConnected
),
silentPreviewInitAttempts:
state.silentPreviewInitAttempts,
lastBridgeFailure:
state.lastBridgeFailure,
customilyLocked: state.customilyLocked,
mirrorFound: Boolean(
state.mirror &&
state.mirror.isConnected
),
mirrorTag: state.mirror
? state.mirror.tagName
: null,
cardCreated: Boolean(
state.card &&
state.card.isConnected
),
cardActive: state.active,
cardVisible: Boolean(
state.card &&
state.card.classList.contains("is-visible")
),
scrollY: Math.round(
window.scrollY ||
window.pageYOffset ||
0
),
startScroll: Math.round(
state.startScroll || 0
),
endScroll: Number.isFinite(
state.endScroll
)
? Math.round(state.endScroll)
: "Infinity",
cardTop: state.card
? Math.round(
state.card.getBoundingClientRect().top
)
: null,
nativePreviewOpenRequests:
state.nativePreviewOpenRequests,
nativePreviewRestoreCount:
state.nativePreviewRestoreCount,
nativePreviewButtonClickCount:
state.nativePreviewButtonClickCount,
observerScope: state.observedGallery
? (
state.observedSourceParent
? "gallery+native-preview"
: "gallery"
)
: "stopped",
scanCount: state.scanCount,
mirrorUpdateCount: state.mirrorUpdateCount,
mutationBatchCount: state.mutationBatchCount,
visualChoiceSync: true,
mirrorPixelSize: state.mirror instanceof HTMLCanvasElement
? state.mirror.width + "x" + state.mirror.height
: "image",
pendingSignature: state.pendingSignature
};
};
window.addEventListener(
"scroll",
requestRender,
{ passive: true }
);
window.addEventListener(
"resize",
handleViewportChange,
{ passive: true }
);
window.addEventListener(
"pageshow",
function () {
if (!state.mediaQuery.matches) return;
if (
state.gallery &&
state.gallery.isConnected &&
state.sourceVisual
) {
if (state.active) {
startObserver(state.gallery);
}
schedulePreviewRefresh(0, true, true);
} else {
scheduleSetupRetries();
}
},
{ passive: true }
);
document.addEventListener(
"shopify:section:load",
function () {
state.gallery = null;
state.sourceVisual = null;
state.sourceScore = -Infinity;
state.customilyLocked = false;
state.layoutCandidatesReady = false;
stopObserver();
scheduleSetupRetries();
}
);
document.addEventListener(
"input",
handleRelevantInteraction,
true
);
document.addEventListener(
"change",
handleRelevantInteraction,
true
);
document.addEventListener(
"click",
handleNativePreviewButtonIntent,
true
);
document.addEventListener(
"click",
handleVisualChoiceInteraction,
true
);
document.addEventListener(
"visibilitychange",
function () {
if (document.hidden) {
stopObserver();
clearPostInputTimers();
clearRefreshTimer();
if (state.frameId) {
window.cancelAnimationFrame(state.frameId);
state.frameId = 0;
}
} else if (state.mediaQuery.matches) {
if (state.gallery && state.gallery.isConnected) {
if (state.active) {
startObserver(state.gallery);
}
schedulePreviewRefresh(0, true, true);
} else {
scheduleSetupRetries();
}
}
}
);
if (window.visualViewport) {
window.visualViewport.addEventListener(
"resize",
handleViewportChange,
{ passive: true }
);
}
if (
typeof state.mediaQuery.addEventListener === "function"
) {
state.mediaQuery.addEventListener(
"change",
handleViewportChange
);
} else if (
typeof state.mediaQuery.addListener === "function"
) {
state.mediaQuery.addListener(
handleViewportChange
);
}
if (document.readyState === "loading") {
document.addEventListener(
"DOMContentLoaded",
scheduleSetupRetries,
{ once: true }
);
} else {
scheduleSetupRetries();
}
})();
